var React = require('react');

function CircleStroke (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.5 19.5C15.4706 19.5 19.5 15.4706 19.5 10.5C19.5 5.52944 15.4706 1.5 10.5 1.5C5.52944 1.5 1.5 5.52944 1.5 10.5C1.5 15.4706 5.52944 19.5 10.5 19.5Z","stroke":"currentColor","strokeWidth":"3"}));
}

CircleStroke.defaultProps = {"className":"svgStroke","width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = CircleStroke;

CircleStroke.default = CircleStroke;
